<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div class="modal_size lg_size">
            <a href="javascript:" class="ui_close" @click="btnClose"><span class="sr_only">popup close</span></a>
            <dl class="modal_content">
                <dt class="ellipsis maintit">
                    <i>{{ $t('TITLE.DASHBOARD.KPI.CONFIG') }}</i>
                    <em class="ico_info">
                        <i class="tooltip fl_btm">
                            {{ $t('MESSAGE.DASHBOARD.KPI.TOOLTIP') }}
                        </i>
                    </em>
                </dt>
                <dd>
                    <div class="box_wrap">
                        <div class="item_four">
                            <div class="step">{{ $t('TITLE.DASHBOARD.KPI.STEP1') }}</div>
                            <div data-type="list" class="tree_box scroll">
                                <ul>
                                    <li v-for="KPI in KPIList"
                                        v-html="KPI.name"
                                        :data-val="KPI.val"
                                        :class="selKPI === KPI.val ? 'active' : ''"
                                        @click="clickKPI(KPI.val)"
                                    ></li>
                                </ul>
                            </div>
                        </div>
                        <div class="item_four" :class="!showCategory2 ? 'disabled' : ''">
                            <div class="step">{{ $t('TITLE.DASHBOARD.KPI.STEP2') }}</div>
                            <div class="tree_box scroll">
                                <dl class="tree_wrap noLine no-margin-top no-border-top"><!-- search_tree 추가 -->
                                    <dd>
                                        <article class="tree_group">
                                            <ul class="tree_list no-margin-top">
                                                <li class="active">
                                                    <a href="javascript:" class="ico_tree" @click="treeClick($event)">
                                                        <span class="sr_only"></span>
                                                    </a>
                                                    <label class="checkbox-wrap">
                                                        <input name="checkAll" type="checkbox" :disabled="!showCategory2" @change="treeChange($event, 'all')"/>
                                                        <i class="check-icon"></i>
                                                        <em>{{ $t('FIELD.GLOBAL.ALL') }}</em>
                                                    </label>
                                                    <ul class="tree_sub_list">
                                                        <li v-for="item in subsidiaryList" :key="pageName + item.code">
                                                            <a href="javascript:" class="ico_tree" @click="treeClick($event, item.subCodeList)">
                                                                <span class="sr_only"></span>
                                                            </a>
                                                            <label class="checkbox-wrap">
                                                                <input
                                                                    type="checkbox"
                                                                    class="region"
                                                                    :name="item.code + '_all'"
                                                                    :value="item.code"
                                                                    :data-name="item.codeName"
                                                                    :disabled="!showCategory2"
                                                                    @change="treeChange($event, item.code)"
                                                                /><i class="check-icon"></i>
                                                                <em>{{ item.codeName }}</em>
                                                            </label>
                                                            <ul class="tree_sub_list" :key="pageName + item.code + inquiryCount">
                                                                <li v-for="subCode in item.subCodeList" :key="pageName + item.code + subCode.code">
                                                                    <label class="checkbox-wrap">
                                                                        <input
                                                                            type="checkbox"
                                                                            class="subsidiary"
                                                                            :name="item.code"
                                                                            :value="subCode.code"
                                                                            :data-name="subCode.codeName"
                                                                            :disabled="!showCategory2"
                                                                            @change="treeChange($event, item.code, subCode.code)"
                                                                        /><i class="check-icon"></i>
                                                                        <em>{{ subCode.codeName }}</em>
                                                                    </label>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </article>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                        <div class="item_four" :class="!showCategory3 ? 'disabled' : ''">
                        <div class="step">{{ $t('TITLE.DASHBOARD.KPI.STEP3') }}</div>
                            <div data-type="list" class="tree_box scroll">
                                <ul>
                                    <li v-for="menuGrpDtl in menuGroupList"
                                        :value="menuGrpDtl.MENU_GROUP_DETAIL_CD"
                                        :data-val="menuGrpDtl.MENU_GROUP_DETAIL_CD"
                                        :class="selMenuGrpDtlList.includes(menuGrpDtl.MENU_GROUP_DETAIL_CD) ? 'active' : ''"
                                        @click="selMenuGroupDetail($event)"
                                    >
                                        {{ menuGrpDtl.MENU_GROUP_DETAIL_NM }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="item_four" :class="!showCategory4 ? 'disabled' : ''">
                            <div class="step">{{ $t('TITLE.DASHBOARD.KPI.STEP4') }}</div>
                            <div class="tree_box scroll">
                                <dl class="tree_wrap noLine no-margin-top no-border-top"><!-- search_tree 추가 -->
                                    <dd>
                                        <article class="tree_group">
                                            <ul class="tree_list no-margin-top">
                                                <li class="active">
                                                    <a href="javascript:" class="ico_tree" @click="catTreeClick($event)">
                                                        <span class="sr_only"></span>
                                                    </a>
                                                    <label class="checkbox-wrap">
                                                        <input name="catCheckAll" type="checkbox" :disabled="!showCategory4" @change="catTreeChange($event, 'all')"/>
                                                        <i class="check-icon"></i>
                                                        <em>{{ $t('FIELD.DASHBOARD.ALL.CATEGORY') }}</em>
                                                    </label>
                                                    <ul class="tree_sub_list">
                                                        <li v-for="item in categoryCodeList" :key="pageName + item.code">
                                                            <a href="javascript:" class="ico_tree" @click="catTreeClick($event, item.subCodeList)">
                                                                <span class="sr_only"></span>
                                                            </a>
                                                            <label class="checkbox-wrap">
                                                                <input
                                                                    type="checkbox"
                                                                    class="category1"
                                                                    :name="item.code + '_all'"
                                                                    :value="item.code"
                                                                    :data-name="item.codeName"
                                                                    :disabled="!showCategory4"
                                                                    @change="catTreeChange($event, item.code)"
                                                                />
                                                                <i class="check-icon"></i>
                                                                <em>{{ item.codeName }}</em>
                                                            </label>
                                                            <ul class="tree_sub_list" :key="pageName + item.code + inquiryCount">
                                                                <li v-for="subCode in item.subCodeList" :key="pageName + item.code + subCode.code">
                                                                    <label class="checkbox-wrap">
                                                                        <input
                                                                            type="checkbox"
                                                                            class="category2"
                                                                            :name="item.code"
                                                                            :value="subCode.code"
                                                                            :data-name="subCode.codeName"
                                                                            :disabled="!showCategory4"
                                                                            @change="catTreeChange($event, item.code, subCode.code)"
                                                                        /><i class="check-icon"></i>
                                                                        <em>{{ subCode.codeName }}</em>
                                                                    </label>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </article>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    <!-- 선택한 항목을 추가 -->
                    <div class="dashboard_btn">
                        <a href="javascript:" class="btn-arrow" @click="btnAddKPI">
                            <span class="sr_only">{{ $t('BUTTON.GLOBAL.ADD') }}</span>
                        </a>
                    </div>
                    <div class="w100p">
                        <div class="step">{{ $t('FIELD.DASHBOARD.SELECTED.CONTENT') }}</div>
                        <div data-type="list" class="tree_box padding5_0 ">
                            <ul v-if="selectContentList.length === 0" class="dashboard_list"><!-- 200617수정 (class추가) -->
                                <em>&nbsp;</em>
                                {{ $t('MESSAGE.GLOBAL.NO.DATA') }}
                            </ul>
                            <ul v-else class="dashboard_list"><!-- 200617수정 (class추가) -->
                                <!-- 컨텐츠 선택형 KPI 의 경우에는 선택한 컨텐츠의 제목과 날짜가 나온다. -->
                                <li v-for="(selCont, idx) in selectContentList">
                                    <em>{{ idx + 1 }}. </em>
                                    <template v-if="['ICO', 'MRCO'].includes(selCont.kpiCd)">
                                        {{ selCont.kpiNm }} > {{ selCont.subNm }} ({{ selCont.menuGrpNm }})
                                    </template>
                                    <template v-else-if="['QA'].includes(selCont.kpiCd)">
                                        {{ selCont.kpiNm }} > {{ selCont.subNm }} > {{ selCont.catNm }}
                                    </template>
                                    <template v-else>
                                        {{ selCont.kpiNm }} > {{ selCont.subNm }} > {{ selCont.menuGrpNm }} > {{ selCont.catNm }}
                                    </template>
                                    <div class="btn-ctrl_wrap">
                                        <span class="button-ctrl_first" @click="btnArrowTop(idx)">{{ $t('BUTTON.GLOBAL.TOP') }}</span>
                                        <span class="button-ctrl_prev" @click="btnArrowUp(idx)">{{ $t('BUTTON.GLOBAL.UP') }}</span>
                                        <span class="button-ctrl_next" @click="btnArrowDown(idx)">{{ $t('BUTTON.GLOBAL.DOWN') }}</span>
                                        <span class="button-ctrl_last" @click="btnArrowBottom(idx)">{{ $t('BUTTON.GLOBAL.BOTTOM') }}</span>
                                        <span class="button-ctrl_del" @click="btnArrowDelete(idx)">{{ $t('BUTTON.GLOBAL.DELETE') }}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_modal_wrap topLine">
                        <div class="btn_right">
                            <a href="javascript:" class="btn_white" @click="btnClose">{{ $t('BUTTON.GLOBAL.CANCEL') }}</a>
                            <a href="javascript:" class="btn_blue" @click="btnSave">{{ $t('BUTTON.GLOBAL.SAVE') }}</a>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import Vue                                  from 'vue';
import axios                                from 'axios';
import qs                                   from 'query-string';
import { mapGetters, mapActions }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import api                                  from '@/service';
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLPagination                        from '~~c/control/pagination/Pagination';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';
import ContentsListPopup                    from './DashboardConfigContentsListPopup';

const fetchMenuGrpDtl = params => axios.post(
    `${SDLUtil.API_URL}/basis/main/listMyMenuGroupDetail.skp`,
    qs.stringify({ corpNo: params.corpNo, loginNo: params.loginNo }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name: 'DashboardConfigPopup',
    props: {
        kpiList: { type: Array, required: true },
        rtnFunc: { type: Function }
    },
    data() {
        return {
            pageName: 'DashboardConfig',
            selKPI: '',
            KPIList: [
                { val: 'IC',    name: 'Important Contents'},
                { val: 'ICO',   name: 'Important Contents<br/>(Only one content)'},
                { val: 'MRC',   name: 'Must-Read Contents'},
                { val: 'MRCO',  name: 'Must-Read Contents<br/>(Only one content)'},
                { val: 'CU',    name: 'Contents Usage '},
                { val: 'CS',    name: 'Contents Satisfaction'},
                { val: 'CC',    name: 'Contents Creation'},
                { val: 'RE',    name: 'Reprocess'},
                { val: 'QA',    name: 'Q&A Status'},
            ],

            contentsId: '',
            contentsDate: '',

            showCategory2: true,
            showCategory3: true,
            showCategory4: true,

            subsidiaryList: [],
            menuGroupList: [],

            selMenuGrpDtlList: [],

            inquiryCount: 0,

            categoryCodeList: [],

            // Save parameter
            selectContentList: [],

        }
    },
    computed: {
        ...mapGetters({
            menus: 'getMenus',
            loginSystem: 'getLoginSystem',
            storeParams: 'getParams',
            userCorpCd: 'getCorpCd',
            loginNo: 'getLoginNo',
            loginRhq: 'getLoginRhq'
        }),
    },
    methods: {
        // 페이지 초기 설정
        async initLoad() {
            SDLUtil.showLoadingBar(true);
            const params = { corpNo: this.userCorpCd, loginNo: this.loginNo };
            const menuData = await fetchMenuGrpDtl(params);
            if(menuData.data.menuGrpDetailList.rowCount > 0) {
                this.menuGroupList = menuData.data.menuGrpDetailList.rowData;
            };

            if(this.kpiList.length > 0) {
                for(let i = 0; i < this.kpiList.length; i++) {
                    let kpi = this.kpiList[i];
                    this.selectContentList.push({
                        kpiCd: kpi.WORK_KEY_1 || '',
                        kpiNm: (this.KPIList.filter((k) => { return k.val === kpi.WORK_KEY_1 ? k.name : '' }))[0].name.replace('<br/>', ' '),
                        subCd: kpi.WORK_KEY_2,
                        subNm: kpi.WORK_KEY_2_NM,
                        menuGrpCd: kpi.WORK_KEY_3,
                        menuGrpNm: kpi.WORK_KEY_3_NM,
                        catCd: kpi.WORK_KEY_4,
                        catNm: kpi.WORK_KEY_4_NM === 'ALL' ? SDLUtil.getMsgProp('FIELD.DASHBOARD.ALL.CATEGORY') : kpi.WORK_KEY_4_NM,
                    });
                }
            };

            SDLUtil.showLoadingBar(false);
        },
        // 단일 컨텐츠 선택
        isOnlyOne(flag = true) {
            this.showCategory2 = !flag;
            this.showCategory3 = !flag;
            this.showCategory4 = !flag;

            // 단일 컨텐츠 선택일 경우에는 선택한 항목 초기화
            if(flag) this.selectedClear();
        },
        selectedClear() {
            // 지역/법인 트리 항목 체크 해제
            $('input[name=checkAll]').prop('checked', false);
            $('input[class=region], input[class=subsidiary]').each(function(idx) { $(this).prop('checked', false); });

            // 선택한 메뉴 그룹 상세 목록 해제
            this.selMenuGrpDtlList = [];

            // 카테고리 트리 항목 체크 해제
            $('input[name=catCheckAll]').prop('checked', false);
            $('input[class=category1], input[class=category2]').each(function(idx) { $(this).prop('checked', false); });
        },
        // KPI 선택 시 이벤트
        clickKPI(type) {
            if(this.selKPI !== type) this.selKPI = type;

            // Important Contents (Only one content), Must read Contents (Only one content) 일 경우
            if(['ICO', 'MRCO'].includes(type)) {
                let self = this;
                this.isOnlyOne(true);

                SDLUtil.show(
                    ContentsListPopup,
                    {
                        kpiType: type,
                        // return function
                        rtnFunc: (params) => {
                            // return Knowledge Id & Reg.Date -> add Selected Content
                            if(!SDLUtil.isNull(params)) {
                                self.contentsId = params.KNOWLEDGE_ID;
                                self.contentsTitle = params.KNOWLEDGE_TITLE;
                                self.contentsDate = params.REG_DT;

                                if(self.selectContentList.length < 3) {
                                    self.selectContentList.push({
                                        kpiCd: self.selKPI,
                                        kpiNm: ( self.KPIList.filter((k) => { return k.val === self.selKPI ? k.name : '' }) )[0].name.replace('<br/>', ' ') || '',
                                        subCd: params.KNOWLEDGE_ID,
                                        subNm: params.KNOWLEDGE_TITLE,
                                        menuGrpCd: params.REG_DT,
                                        menuGrpNm: params.REG_DATE,
                                        catCd: 'ALL',
                                        catNm: 'ALL'
                                    });

                                }  else {
                                    return SDLUtil.alert('MESSAGE.DASHBOARD.ONLY.THREE.ITEMS');
                                };
                            };

                            self.isOnlyOne(false);
                            this.selKPI = '';
                        }
                    },
                    { height: 'auto' }
                );

            // 그 외 KPI 선택
            } else if(['QA'].includes(type)) {
                this.isOnlyOne(false);
                this.showCategory3 = false;

            } else {
                this.isOnlyOne(false);
            }
        },
        // 코드 콤보 목록을 가져오는 API
        async getCodeComboList(categoryVal, categoryCode, addVal) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, addVal);
            return codeResp;
        },
        // 국가/법인 목록을 가져온다
        setSubsidiaryList(v, recursion) {
            let codeCategoryId = '';
            let parentCode = '';
            if (v === 1) {
                codeCategoryId = 'RHQ_AUTH_ACCESS_CD';
                parentCode = this.loginNo;
                this.getCodeComboList(parentCode, codeCategoryId, this.loginNo).then(resp => {
                    this.subsidiaryList = resp;
                    for (const category of this.subsidiaryList) {
                        this.setSubsidiaryList(2, category.code);
                    }
                });
            } else if (v === 2) {
                codeCategoryId = 'SUB_AUTH_ACCESS_CD';
                parentCode = recursion;
                this.getCodeComboList(parentCode, codeCategoryId, this.loginNo).then(resp => {
                    for (const category of this.subsidiaryList) {
                        if (category.code === resp[0].parentCode) {
                            category.subCodeList = resp;
                            this.inquiryCount += 1;
                            return;
                        }
                    }
                });
            }
        },
        // 국가/법인 트리 클릭
        treeClick(e) {
            $(e.target).closest("li").on("click", function() {
                if( $(e.target).closest("li").hasClass('active') == true){
                    $(e.target).closest('li').removeClass('active');

                } else {
                    //$('.tree_list > li').removeClass('active');
                    $(e.target).closest('li').removeClass('active');
                    $(e.target).closest('li').addClass('active');
                }
            });
        },
        // 국가/법인 트리 변경
        treeChange(e, v1, v2) {
            // 모든 항목 체크
            if(SDLUtil.nvl(v1) === 'all') {
                if ($(e.target).is(':checked')) {
                    $('input[class=region], input[class=subsidiary]').each(function(idx) {
                        $(this).prop('checked', true);
                    });

                } else {
                    $('input[class=region], input[class=subsidiary]').each(function(idx) {
                        $(this).prop('checked', false);
                    });
                }

            // Lv2 노드 체크
            } else if (SDLUtil.isNull(v2)) {
                if ($(e.target).is(':checked')) {
                    this.treeOneCheck(e);
                    $('input[name=' + v1 + ']').each(function(idx) {
                        $(this).prop('checked', true);
                    });

                } else {
                    $('input[name=' + v1 + ']').each(function(idx) {
                        $(this).prop('checked', false);
                    });
                }

                this.treeAllCheck();

            // Lv1 노드 체크
            } else {
                this.treeOneCheck(e);
                var _$length = $('input[name=' + v1 + ']').length;
                if ($('input[name=' + v1 + ']:checked').length == _$length) {
                    $('input[name=' + v1 + '_all]').prop('checked', true);

                } else {
                    $('input[name=' + v1 + '_all]').prop('checked', false);
                }

                this.treeAllCheck();
            }
        },
        // 국가/법인 트리 체크, 하나의 항목만 선택 가능하도록 체크 전 모든 항목을 해제 한다.
        treeOneCheck(e) {
            let _$cLength = $('input[class=region]:checked, input[class=subsidiary]:checked').length;
            if(_$cLength > 1) {
                $('input[name=checkAll]').prop('checked', false);
                $('input[class=region], input[class=subsidiary]').each(function(idx) {
                    $(this).prop('checked', false);
                });

                $(e.target).prop('checked', true);
            };
        },
        // 국가/법인 트리 모든 항목 체크
        treeAllCheck() {
            var _$length = $('input[class=region], input[class=subsidiary]').length,
                _$cLength = $('input[class=region]:checked, input[class=subsidiary]:checked').length;

            if(_$length == _$cLength) {
                $('input[name=checkAll]').prop('checked', true);

            } else {
                $('input[name=checkAll]').prop('checked', false);
            }
        },
        // 카테고리 목록 출력 함수
        setCategoryList(v, recursion) {
            let codeCategoryId = '';
            let parentCode = '';
            if (v === 1) {
                codeCategoryId = 'ADM_CATEGORY_A';
                parentCode = '0';
                this.getCodeComboList(parentCode, codeCategoryId, this.userCorpCd).then(resp => {
                    this.categoryCodeList = resp;
                    for (const category of this.categoryCodeList) {
                        this.setCategoryList(2, category.code);
                    }
                });
            } else if (v === 2) {
                codeCategoryId = 'ADM_CATEGORY_B';
                parentCode = recursion;
                this.getCodeComboList(parentCode, codeCategoryId, this.userCorpCd).then(resp => {
                    for (const category of this.categoryCodeList) {
                        if (category.code === resp[0].parentCode) {
                            category.subCodeList = resp;
                            this.inquiryCount += 1;
                            return;
                        }
                    }
                });
            }
        },
        // 카테고리 클릭
        catTreeClick(e) {
            $(e.target).closest("li").on("click", function() {
                if( $(e.target).closest("li").hasClass('active') == true){
                    $(e.target).closest('li').removeClass('active');

                } else {
                    //$('.tree_list > li').removeClass('active');
                    $(e.target).closest('li').removeClass('active');
                    $(e.target).closest('li').addClass('active');
                }
            });
        },
        // 카테고리 변경
        catTreeChange(e, v1, v2) {
            console.log(e, v1, v2);
            // 모든 항목 체크
            if(SDLUtil.nvl(v1) === 'all') {
                if ($(e.target).is(':checked')) {
                    $('input[class=category1], input[class=category2]').each(function(idx) {
                        $(this).prop('checked', true);
                    });

                } else {
                    $('input[class=category1], input[class=category2]').each(function(idx) {
                        $(this).prop('checked', false);
                    });
                }

            // Lv2 노드 선택
            } else if (SDLUtil.isNull(v2)) {
                if ($(e.target).is(':checked')) {
                    this.catTreeOneCheck(e);
                    $('input[name=' + v1 + ']').each(function(idx) {
                        $(this).prop('checked', true);
                    });

                } else {
                    $('input[name=' + v1 + ']').each(function(idx) {
                        $(this).prop('checked', false);
                    });
                }

                this.catTreeAllCheck();

            // Lv1 노드 선택
            } else {
                this.catTreeOneCheck(e);
                var _$length = $('input[name=' + v1 + ']').length;
                if ($('input[name=' + v1 + ']:checked').length == _$length) {
                    $('input[name=' + v1 + '_all]').prop('checked', true);

                } else {
                    $('input[name=' + v1 + '_all]').prop('checked', false);
                }

                this.catTreeAllCheck();
            }
        },
        // 카테고리 트리 체크, 하나의 항목만 선택 가능하도록 체크 전 모든 항목을 해제 한다.
        catTreeOneCheck(e) {
            let _$cLength = $('input[class=category1]:checked, input[class=category2]:checked').length;
            if(_$cLength > 1) {
                $('input[name=catCheckAll]').prop('checked', false);
                $('input[class=category1], input[class=category2]').each(function(idx) {
                    $(this).prop('checked', false);
                });

                $(e.target).prop('checked', true);
            };
        },
        // 모든 카테고리 항목 체크
        catTreeAllCheck() {
            var _$length = $('input[class=category1], input[class=category2]').length,
                _$cLength = $('input[class=category1]:checked, input[class=category2]:checked').length;

            if(_$length == _$cLength) {
                $('input[name=catCheckAll]').prop('checked', true);

            } else {
                $('input[name=catCheckAll]').prop('checked', false);
            }
        },
        // 메뉴그룹상세 트리 선택
        selMenuGroupDetail(e) {
            if(this.showCategory3) {
                let val = e.target.getAttribute('value'),
                    text = e.target.innerHTML.trim() || '',
                    tempList = [];

                if(!this.selMenuGrpDtlList.includes(val)) {
                    this.selMenuGrpDtlList.push(val);

                } else {
                    let idx = _.findIndex(this.selMenuGrpDtlList, function(m) { return m === val; });
                    this.selMenuGrpDtlList.splice(idx, 1);
                }

                // 선택한 메뉴그룹이 4개 이상이면 마지막 추가된 항목은 삭제
                if(this.selMenuGrpDtlList.length > 4) {
                    this.selMenuGrpDtlList.splice(this.selMenuGrpDtlList.length - 1, 1);
                };
            };
        },
        // Add Selected KPI
        btnAddKPI() {
            if(this.selectContentList.length < 3) {
                let that = this, addKpi = {};
                let step1Cd = '', step1Nm = '', step2Cd = '', step2Nm = '',
                    step3Cd = '', step3Nm = '', step4Cd = '', step4Nm = '';
                // KPI 선택 확인
                if(this.selKPI) {
                    step1Cd = this.selKPI;
                    step1Nm = ( this.KPIList.filter((k) => { return k.val === step1Cd ? k.name : '' }) )[0].name.replace('<br/>', ' ') || '';

                } else {
                    return SDLUtil.alert('MESSAGE.DASHBOARD.SELECT.KPI');
                };

                // 지역/법인 선택 확인
                let $allRegSubLength = $('input[class=region], input[class=subsidiary]').length,
                    $allCheckRegSubLength = $('input[class=region]:checked, input[class=subsidiary]:checked').length;
                if($allRegSubLength === $allCheckRegSubLength) {
                    if($('input[class=subsidiary]').length === 1) {
                        step2Cd = $('input[class=subsidiary]:checked').val();
                        step2Nm = $('input[class=subsidiary]:checked').attr('data-name');

                    } else {
                        step2Cd = 'ALL', step2Nm = 'All';
                    }

                } else if($allCheckRegSubLength === 0 && !['ICO', 'MRCO'].includes(this.selKPI)) {
                    return SDLUtil.alert('MESSAGE.DASHBOARD.SELECT.SUBSIDIARY');

                } else {
                    if( $('input[class=region]:checked').length === 1 && $('input[class=subsidiary]:checked').length >= 1) {
                        let regionLength = $('input[class=subsidiary]:checked').length, tempArr = [];
                        for(let i = 0; i < regionLength; i++) {
                            tempArr.push($('input[class=subsidiary]:checked')[i].value);
                        };

                        step2Cd = tempArr.join(',');
                        step2Nm = $('input[class=region]:checked').attr('data-name');

                    } else if( $('input[class=subsidiary]:checked').length > 0 ){
                        step2Cd = $('input[class=subsidiary]:checked').val();
                        step2Nm = $('input[class=subsidiary]:checked').attr('data-name');
                    }
                };

                // 메뉴 그룹 코드
                if(this.selMenuGrpDtlList.length > 0) {
                    let selectedMenuList = this.menuGroupList.filter((m) => { return  that.selMenuGrpDtlList.includes(m.MENU_GROUP_DETAIL_CD) ? m.MENU_GROUP_DETAIL_NM : '' });
                    step3Cd = selectedMenuList.map((s) => s.MENU_GROUP_DETAIL_CD).join(',');
                    step3Nm = selectedMenuList.map((s) => s.MENU_GROUP_DETAIL_NM).join(', ');

                } else if(!['ICO', 'MRCO', 'QA'].includes(this.selKPI)){
                    return SDLUtil.alert('MESSAGE.DASHBOARD.SELECT.MENUGRP');
                };

                // 카테고리 선택 확인
                let $allCatLength = $('input[class=category1], input[class=category2]').length,
                    $allCheckCatLength = $('input[class=category1]:checked, input[class=category2]:checked').length;
                if($allCatLength === $allCheckCatLength) {
                    if($('input[class=category2]').length === 1) {
                        step4Cd = $('input[class=category2]:checked').val();
                        step4Nm = $('input[class=category2]:checked').attr('data-name');

                    } else {
                        step4Cd = 'ALL', step4Nm = 'All the Category';
                    }

                } else if($allCheckCatLength === 0 && !['ICO', 'MRCO'].includes(this.selKPI)) {
                    return SDLUtil.alert('MESSAGE.DASHBOARD.SELECT.CATEGORY');

                } else {
                    if( $('input[class=category1]:checked').length > 0 ) {
                        step4Cd = $('input[class=category1]:checked').val();
                        step4Nm = $('input[class=category1]:checked').attr('data-name');

                    } else if( $('input[class=category2]:checked').length > 0 ){
                        step4Cd = $('input[class=category2]:checked').val();
                        step4Nm = $('input[class=category2]:checked').attr('data-name');
                    }
                };

                this.selectContentList.push({
                    kpiCd: step1Cd,
                    kpiNm: step1Nm,
                    subCd: step2Cd,
                    subNm: step2Nm,
                    menuGrpCd: step3Cd,
                    menuGrpNm: step3Nm,
                    catCd: step4Cd,
                    catNm: step4Nm,
                });

                this.selKPI = '';
                this.selectedClear();

            } else {
                return SDLUtil.alert('MESSAGE.DASHBOARD.ONLY.THREE.ITEMS');
            }
        },
        btnArrowTop(idx) {
            if(idx >= 0) {
                let newList = this.selectContentList,
                    moveRow = this.selectContentList[idx];

                newList.splice(idx, 1);
                newList.splice(0, 0, moveRow);

                this.selectContentList = newList;
            };
        },
        btnArrowUp(idx) {
            if(idx >= 0) {
                let newList = this.selectContentList,
                    moveRow = this.selectContentList[idx];
                let newIdx = idx - 1;
                if(newIdx <= 0) newIdx = 0;
                newList.splice(idx, 1);
                newList.splice(newIdx, 0, moveRow);

                this.selectContentList = newList;
            };
        },
        btnArrowDown(idx) {
            if(idx <= this.selectContentList.length) {
                let newList = this.selectContentList,
                    moveRow = this.selectContentList[idx];
                let newIdx = idx + 1;
                if(newIdx >= this.selectContentList.length) { newIdx = this.selectContentList.length; }
                newList.splice(idx, 1);
                newList.splice(newIdx, 0, moveRow);

                this.selectContentList = newList;
            };
        },
        btnArrowBottom(idx) {
            if(idx <= this.selectContentList.length) {
                let newList = this.selectContentList,
                    moveRow = this.selectContentList[idx];

                newList.splice(idx, 1);
                newList.splice(this.selectContentList.length, 0, moveRow);

                this.selectContentList = newList;
            };
        },
        btnArrowDelete(idx) {
            this.selectContentList.splice(idx, 1);
        },
        btnClose() {
            if(!SDLUtil.isNull(this.selKPI)) {
                SDLUtil.confirm({
                    title: 'TITLE.WARNING.TITLE',
                    msg: 'MESSAGE.POPUP.CHANGE.CLOSE',
                    okLabel: 'BUTTON.GLOBAL.OK',
                    onOkEvt: () => { this.$emit('close') },
                })

            } else {
                this.$emit('close');
            }
        },
        async btnSave() {
            // Vue.$log.info('Selected config =>', this.selectContentList);
            if(this.selectContentList.length > 3) {
                return SDLUtil.alert('MESSAGE.DASHBOARD.ONLY.THREE.ITEMS');
            
            } else {
                let params = {
                    WORK_TYPE: 'DASHBOARD',
                    WORK_LIST: JSON.stringify(this.selectContentList)
                };

                await axios.post( 
                        `${SDLUtil.API_URL}/basis/main/setMySetting.skp`,
                        qs.stringify(params),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                    })
                    .then(res => {
                        SDLUtil.showLoadingBar(false);
                        this.rtnFunc( true );
                        this.$emit('close');
                    })
                    .catch(err => {
                        SDLUtil.showLoadingBar(false);
                        SDLUtil.alert(err);
                    });
            }
        }
    },
    created() {
        // Popup create
        this.setSubsidiaryList(1);
        this.setCategoryList(1);
        this.initLoad();
    },
    mounted() {
        this.$nextTick( () => {
            $('.tree_list > li .ico_tree').on("click",function(){
                if( $(this).closest("li").hasClass('active') == true){
                    $(this).closest('li').removeClass('active');
                } else {
                    //$('.tree_list > li').removeClass('active');
                    $(this).closest('li').removeClass('active');
                    $(this).closest('li').addClass('active');
                }
            });
        });
    }
};
</script>
<style scoped>
.no-border-top { border-top: 0px !important; }
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/dashboard/popup/DashboardConfigPopup.vue